import React from "react";

// Simple inline SVGs (avoid extra icon lib) — always circle-outlined dark buttons.
export const TelegramIcon = (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M21.94 4.05c-.29-.24-.71-.28-1.05-.13L2.99 11.79c-.34.15-.55.49-.53.86.02.37.28.68.64.79l4.72 1.43 1.71 5.35c.1.32.36.55.68.61.06.01.11.02.17.02.26 0 .5-.11.68-.3l2.63-2.83 4.61 3.4c.17.13.38.19.59.19.11 0 .21-.02.31-.05.31-.1.55-.36.62-.68l3.02-15c.08-.35-.05-.72-.32-.94Zm-6.02 4.31L9.42 14.5l-.29 3.34-1.13-3.54 8.15-6.51c.13-.11.31-.11.44.02.13.13.13.32.02.44Z" />
    </svg>
);
export const TwitterIcon = (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M18.244 2H21l-6.52 7.454L22 22h-6.238l-4.888-6.397L5.2 22H2.44l6.98-7.98L2 2h6.36l4.42 5.86L18.244 2Zm-1.093 18.155h1.72L7.936 3.76H6.09l11.061 16.395Z" />
    </svg>
);
export const LinkedInIcon = (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M20.45 3H3.55A.55.55 0 0 0 3 3.55v16.9c0 .3.25.55.55.55h16.9c.3 0 .55-.25.55-.55V3.55c0-.3-.25-.55-.55-.55ZM8.34 18.34H5.67V9.75h2.67v8.59Zm-1.34-9.77a1.55 1.55 0 1 1 0-3.1 1.55 1.55 0 0 1 0 3.1Zm11.34 9.77H15.7V14.2c0-.99-.02-2.26-1.38-2.26-1.38 0-1.6 1.08-1.6 2.19v4.21H10.05V9.75h2.56v1.18h.04c.36-.68 1.23-1.4 2.53-1.4 2.71 0 3.21 1.79 3.21 4.11v4.7Z" />
    </svg>
);
export const InstagramIcon = (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
    </svg>
);
